import type { AppConfigKey } from "@/config/app-config";
import { getAppConfigKey, isSandbox, listAppConfigKeys, setAppConfigKey } from "@/config/app-config";
import { cn } from "@EspaceParkQC/sdk-react";
import { useReducer } from "react";
import { DebugButton } from "./debug-button";
import { DebugRadioGroup } from "./debug-radio-group";
import { DebugSection } from "./debug-section";

const formatConfigKeyLabel = (key: string): string => {
  if (key.startsWith("local:")) {
    return `Local (${key.split(":")[1].charAt(0).toUpperCase() + key.split(":")[1].slice(1)})`;
  }

  return key.charAt(0).toUpperCase() + key.slice(1);
};

export default function DevTools(): React.ReactElement | null {
  const [isDisplayed, toggleDisplay] = useReducer((state) => !state, false);

  if (!isSandbox()) return null;

  function onConfigChange(value: AppConfigKey): void {
    if (
      confirm("Are you sure you want to change the environment? You will need to login again in the new environment.")
    ) {
      setAppConfigKey(value);
      window.location.href = "/";
    }
  }

  return (
    <div className={cn("fixed top-auto bottom-3 left-3 z-30 flex flex-col items-start justify-end")}>
      {isDisplayed && (
        <div className="border-border bg-card text-card-foreground mb-2.5 divide-y divide-border rounded-xl border-2 shadow-md">
          <DebugSection title="Environment" subtitle="Requires a new login to take effect">
            <DebugRadioGroup
              options={listAppConfigKeys().map((key) => ({
                label: formatConfigKeyLabel(key),
                value: key,
              }))}
              selectedOption={getAppConfigKey()}
              onChange={(value) => onConfigChange(value as AppConfigKey)}
            />
          </DebugSection>
        </div>
      )}

      <DebugButton
        label={`Dev Tools · ${formatConfigKeyLabel(getAppConfigKey())}`}
        onClick={toggleDisplay}
        toggled={isDisplayed}
      />
    </div>
  );
}
